import { render } from "./DTableColumn.vue?vue&type=template&id=1bceda51"
import script from "./DTableColumn.vue?vue&type=script&lang=js"
export * from "./DTableColumn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__